import React, { useMemo, useState } from "react";
import {
    DatePicker,
    FormGroup,
} from "components/common";
import { Button} from "reactstrap";
import { Trans } from "react-i18next";
import { Control, LocalForm, Field } from "react-redux-form";
import Select from "react-select";
import InputFile from "components/common/InputFile";

export const InputFileWrapper = ({ model, file, setData, innerRef, InputName = "attachment" }) => {
    return (
        <Field 
            model={model}
            component={InputFile}
            file={file}
            setData={setData}
            innerRef={innerRef}
            InputName={InputName}
        />
    );
};

const getOptions = (options) => {
    options.map((option) => {
        option.label = option.name
        option.value = option.id
    })
    return options
};

export const Edit = ({ 
    t,
    UpdateItemModal,
    SetUpdateItemModal,
    handleCreateUpdateStageRowSubmit,
    listColumns,
    selectedRowId,
    stageRows,
    selectedStageId,
}) => {
    const [attachment, setFile] = useState(null);
    const selectedStageObj = useMemo(() => {
        return stageRows?.find(stage => stage?.id === selectedStageId) || null;
    }, [stageRows, selectedStageId]);
    const selectedRow = useMemo(() => {
        return selectedStageObj?.list_stage_rows?.find(row => row?.id === selectedRowId) || null;
    }, [selectedStageObj, selectedRowId]);

    return (
        <UpdateItemModal title={t(`${selectedRowId ? "Update" : "Create"} item`)}>
            <LocalForm
                className="col"
                onSubmit={(values) => handleCreateUpdateStageRowSubmit(values)}
                initialState={
                    selectedRow?.cell_mapping || {}
                }
            >
                {listColumns && listColumns.map((item, index) => {
                    const cellData = selectedRow?.cell_mapping?.[item?.id];
                    
                    return (
                        <div key={item?.id}>
                            {item.type === "text" && (
                                <FormGroup
                                    label={`${item.name}${item?.is_required_field ? " *" : ""}`}
                                    className="mb-3"
                                >
                                    <Control.text
                                        model={`.${item.id}.column_value`}
                                        className="form-control"
                                        placeholder={`Enter ${item?.name}`}
                                        required={item?.is_required_field}
                                    />
                                </FormGroup>
                            )}
                            {item.type === "hyperlink" && (
                                <FormGroup
                                    label={`${item.name}${item?.is_required_field ? " *" : ""}`}
                                    className="mb-3"
                                >
                                    <Control.text
                                        model={`.${item.id}.column_value`}
                                        className="form-control"
                                        placeholder={`Enter ${item?.name}`}
                                        required={item?.is_required_field}
                                    />
                                </FormGroup>
                            )}
                            {item.type === "number" && (
                                <FormGroup
                                    label={`${item.name}${item?.is_required_field ? " *" : ""}`}
                                    className="mb-3"
                                >
                                    <Control.text
                                        model={`.${item.id}.column_value`}
                                        className="form-control"
                                        placeholder={`Enter ${item?.name}`}
                                        type="number"
                                        required={item?.is_required_field}
                                    />
                                </FormGroup>
                            )}
                            {item.type === "date" && (
                                <FormGroup
                                    label={`${item.name}${item?.is_required_field ? " *" : ""}`}
                                    className="mb-3"
                                >
                                    <DatePicker
                                        model={`.${item.id}.column_value`}
                                        className="form-control"
                                        selected={
                                            cellData?.column_value_date
                                                ? new Date(cellData.column_value_date)
                                                : null
                                        }
                                        placeholderText={`Enter ${item?.name}`}
                                        required={item?.is_required_field}
                                    />
                                </FormGroup>
                            )}
                            {item.type === "yes_no" && (
                                <FormGroup
                                    label={`${item.name}${item?.is_required_field ? " *" : ""}`}
                                    style={{marginBottom: "2.3rem"}}
                                >
                                    <Control.checkbox
                                        model={`.${item.id}.column_value`}
                                        className="form-check-input  ml-1"
                                        defaultChecked={!!cellData?.column_value_yes_no}
                                        required={item?.is_required_field}
                                    />
                                </FormGroup>
                            )}
                            {item.type === "textarea" && (
                                <FormGroup
                                    label={`${item.name}${item?.is_required_field ? " *" : ""}`}
                                    className="mb-3"
                                >
                                    <Control.textarea
                                        model={`.${item.id}.column_value`}
                                        className="form-control"
                                        placeholder={`Enter ${item?.name}`}
                                        required={item?.is_required_field}
                                    />
                                </FormGroup>
                            )}
                            {item.type === "image" && (
                                <FormGroup label={`${item.name}${item?.is_required_field ? " *" : ""}`} className="mb-2">
                                    <InputFileWrapper 
                                        model={`${item.id}.column_value`}
                                        file={attachment || cellData?.column_value_image || ""}
                                        setData={setFile}
                                    />
                                </FormGroup>
                            )}
                            {item.type === "choice" && (
                                <FormGroup
                                    addControlClass={false}
                                    className="mb-3"
                                    label={`${item?.name}${item?.is_required_field ? " *" : ""}`}
                                >
                                    <Control.text
                                        model={`.${item?.id}.column_value`}
                                        style={{ backgroundColor: "#F4F7FE" }}
                                        component={Select}
                                        simpleValue
                                        options={getOptions(item.column_choices)}
                                        
                                        required={item?.is_required_field}
                                    />
                                </FormGroup>
                            )}
                        </div>
                    );
                })}
                
                <div className="d-flex justify-content-end mt-3 px-0">
                    <Button color="secondary" onClick={() => {SetUpdateItemModal()}}>
                        <Trans>Close</Trans>
                    </Button>
                    <Button className="mr-0" color="primary" type="submit">
                        <Trans>Save</Trans>
                    </Button>
                </div>
            </LocalForm>
        </UpdateItemModal>
    );
};

export default Edit;
